import styled from "styled-components";

export const YourBid = styled.span`
    color:  ${({yourBid}) => yourBid ? "var(--green-color)" : "inherit" } ;

`
